export class Sec002Model {
    siloDestino: string = '';
}